<template>
  <div v-if="hasAssets" class="article-downloads">
    <div class="h3">Downloads</div>
    <ul class="icon-list icon-list--xxs">
      <li v-for="asset in downloads" :key="`asset-${asset.id}`">
        <a
          :aria-label="'Download ' + assetTitle(asset)"
          :href="asset.filename"
          :title="assetTitle(asset)"
        >
          <i class="icon icon--xl">
            <Icon :name="assetIconName(asset)" />
          </i>
          <span class="title">
            {{ assetTitle(asset) }}
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
type DownloadAsset = {
  id: string
  filename: string
  title?: string
}
const props = defineProps<{
  downloads: DownloadAsset[]
}>()

const hasAssets = computed(() => !!props.downloads?.[0])
const assetTitle = (asset: DownloadAsset) =>
  asset.title ? asset.title : assetFilename(asset)
const assetFilename = (asset: DownloadAsset) =>
  asset.filename.split('/').pop()?.split('.')[0]
const assetExtension = (asset: DownloadAsset) => asset.filename.split('.').pop()
const assetIconName = (asset: DownloadAsset) => {
  const extension = assetExtension(asset)
  if (!extension) return 'IconFile'

  if (['jpeg', 'jpg', 'png', 'gif', 'svg', 'wepb'].includes(extension)) {
    return 'fa6-regular:file-image'
  }
  if (['pdf'].includes(extension)) {
    return 'fa6-regular:file-pdf'
  }
  if (['mp4', 'mpeg', 'webm', 'mov', 'avi'].includes(extension)) {
    return 'fa6-regular:file-video'
  }
  if (['mp3', 'wav'].includes(extension)) {
    return 'fa6-regular:file-audio'
  }
  return 'fa6-regular:file'
}
</script>

<style lang="less" scoped>
.article-downloads {
  .rounded-sm();

  margin: @gutter-lg 0;
  background: @color-fill-pale;
  padding: @gutter-lg @gutter-sm @gutter-sm;
  max-width: @375px;

  .h3 {
    margin: 0 0 @gutter-sm @gutter-xs - @3px;
  }

  ul.icon-list {
    li {
      border-color: darken(@color-border, 8%);
      padding-right: @gutter-xxs;

      span {
        &.extension {
          .font-xxs();
        }
      }

      > a {
        background: none;
        border: none;
      }
    }
  }
}
</style>
